%fila {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 20px;
	padding: 12px 10px;
	border-bottom: 1px solid #d8e0e8;
}

.container {
	position: absolute;
	left: 0;
	bottom: 0;
	width: 100%;
	z-index: 2;
	background: #fff;
	color: #000;
	border-radius: 4px;
	font-family: 'Ringside', sans-serif;
	font-size: 16px;
	line-height: 18px;
	border: 1px solid #d8e0e8;
	animation: tooltip-in 0.35s ease-out both;

	@media (prefers-reduced-motion: reduce) {
		animation: none;
	}

	@container (min-width: 599px) {
		bottom: 20px;
		right: 20px;
		left: auto;
		z-index: 10;
		max-width: 300px;
		box-shadow:
			0 4px 4px -4px rgba(0, 0, 0, 0.1),
			0 16px 32px -4px rgba(0, 0, 0, 0.2);
	}
	header {
		@extend %fila;
		background: #d8e0e8;
		button {
			cursor: pointer;
			margin-left: auto;
		}
	}
	.fons_gris {
		background-color: #f4f6f8;
	}
	.contingut {
		display: flex;
		flex-direction: column;
		> p {
			@extend %fila;
		}
		.punts {
			display: inline-block;
			min-width: 12px;
			min-height: 12px;
			max-width: 12px;
			max-height: 12px;
			background-color: #0b69f7;
			border: 2px solid #fff;
			border-radius: 50%;
		}
		.totalitat {
			border-bottom: 1px solid #d8e0e8;
			background-color: #f4f6f8;
			> p {
				@extend %fila;
				padding-inline: 0;
				margin-inline: 10px;
				&:last-child {
					border-bottom: none;
				}
			}
		}
	}
	.nota {
		@extend %fila;
		padding-inline: 0;
		margin-inline: 10px;
		font-size: 14px;
		line-height: 16px;
		&:last-child {
			border-bottom: none;
		}
	}
}

@keyframes tooltip-in {
	from {
		opacity: 0;
		transform: translateY(18px) scaleY(0.96);
		transform-origin: bottom;
	}
	to {
		opacity: 1;
		transform: translateY(0) scaleY(1);
	}
}
